export const SET_PROJECT = 'SET_PROJECT';
export const SET_DISTRICT = 'SET_DISTRICT';
export const SET_DISTRICTS = 'SET_DISTRICTS';
export const SET_LANG = 'SET_LANG';
export const SET_UUID = 'SET_UUID';
export const SET_LOCALITY = 'SET_LOCALITY';
export const SET_PLUGINID = 'SET_PLUGINID';
